import React from "react";
// import { Avatar } from "../atoms/Avatar";
import "../../styles/components/_loading.css";
import { Grid } from "@mui/material";

import { useEffect, useState } from "react";
import useAuth from "../../hooks/useAuth";

interface LoaderProps {
  color?: string;
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  title?: string;
}

export const Loader = ({ color = "blue", size = "md", title }: LoaderProps) => {
  const [dots, setDots] = useState("");
  const user = useAuth();

  function sizeToNumber(size: string): number {
    const map: Record<string, number> = {
      xs: 32,
      sm: 48,
      md: 72,
      lg: 96,
      xl: 128,
    };

    return map[size] ?? 72;
  }

  //const companyName = user?.company_client?.name ?? "Ellie Care";

  const logoSrc = getLogoSrc(user?.company_client?.name ?? "Ellie Care");

  function getLogoSrc(companyName?: string): string {
    const logoSrc = user?.company_client?.prefix; //companyName ? logos[companyName] || logos.default : logos.default
    // console.log(logoSrc !== undefined ? logoSrc : "ELLIE")
    // console.log(logoSrc)
    return `https://elliecare-public-images.s3.sa-east-1.amazonaws.com/cc-logos/${
      logoSrc !== undefined ? logoSrc : "ELLIE"
    }.svg`;
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev.length < 3 ? prev + "." : ""));
    }, 500); // cada 500ms añade un punto hasta 3
    return () => clearInterval(interval);
  }, []);

  return (
    <Grid display="flex" alignItems="center" flexDirection="column" p={2}>
      {/* <Avatar
        variation={2}
        size={size}
        className="w-min-content loading-screen__avatar"
      /> */}
      <img
        src={logoSrc}
        alt="avatar"
        className={"w-min-content loading-screen__avatar"}
        style={{ maxWidth: sizeToNumber(size) }}
      />
      {title && (
        <h4 className="text-description">
          {title}
          <span>{dots}</span>
        </h4>
      )}
    </Grid>
  );
};
